
export const USER_MESSAGE = "USER_MESSAGE";
export function clearMessage() {
  return dispatch => {
    dispatch({ type: USER_MESSAGE, msgType: "", text: "", key: "" });
  };
}
